<template>
    <v-dialog v-model="model" width="500">
        <v-card class="text-xs-center">
            <v-card-text>
                {{ 'It is only' | translation }} {{ buyableAmount }} {{ 'Products in stock' | translation }}
            </v-card-text>

            <v-card-actions>
                <v-spacer />

                <v-btn color="primary" @click="model = false">
                    {{ 'shut down' | translation }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
        },
        buyableAmount: {
            type: Number|String,
        },
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
};
</script>
